<template>
  <div :class="[_isMobile() ? 'mobile' : 'bg']">
    <div class="btns">
      <a-button @click="toHome">回到首页</a-button>
      <a-divider type="vertical"></a-divider>
      <a-button @click="logout">退出登录</a-button>
    </div>
    <div class="container">
      <div class="header">
        <h1>
          {{
            $store.getters.userInfo.realname || $store.getters.userInfo.username
          }}
          人工智能核心素养档案查询页
        </h1>
        <!-- <a-divider></a-divider> -->
      </div>
      <div class="list-wrap">
        <a-row :gutter="[_isMobile() ? 0 : 256]" type="flex" justify="center" align="middle" style="height: 500px;">
          <a-col :xs="21" :sm="21" :md="12"  :lg="12" class="list-col">
            <!-- <h2></h2> -->
            <!-- <a-divider>AICE证书列表</a-divider> -->
            <div v-for="(d, i) in docList" :key="i">
              <a-alert type="info" style="max-width: 500px; margin: auto">
                <div slot="message">
                  <a-row>
                    <a-col :span="19" ><span>{{ d.eventParentCategory + " " + d.eventCategory}}</span></a-col>
                    <a-col :span="4" :offset="1">
                      <a-button :disabled="!d.awardGrant" size="small" @click="toCert(d.awardGrant.awardFile)" >{{ d.awardGrant ? "下载" : "未开放" }}</a-button>
                    </a-col>
                  </a-row>
                </div>
              </a-alert>
              <br />
            </div>
          </a-col>
          <a-col :xs="21" :sm="21" :md="12"  :lg="12" class="list-col">
            <!-- <h2></h2> -->
            <!-- <a-divider>AICE人工智能核心素养评价报告</a-divider> -->
            <div v-for="(d, i) in docList" :key="i">
              <!-- <a-alert v-show="d.canQueryScoreReport" type="success" style="max-width: 500px; margin: auto"> -->
              <a-alert type="success" style="max-width: 500px; margin: auto">
                <div slot="message">
                  <a-row>
                    <a-col :span="19"><span>{{ d.eventParentCategory + " " + d.eventCategory}}</span></a-col>
                    <a-col :span="4" :offset="1">
                      <a-button :disabled="!d.canQueryScoreReport" size="small" @click="toReport(d.eventApplyId)" >{{ d.canQueryScoreReport ? "下载" : "未开放" }}</a-button>
                    </a-col>
                  </a-row>
                </div>
              </a-alert>
              <br />
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="footer">
      <h2>Copyright 2023 中国自动化学会智慧教育专业委员会 普及工作委员会</h2>
    </div>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import { mapActions } from "vuex";
import {mixinDevice} from '@/utils/mixin.js'
export default {
  name: "AidocList",
  mixins: [mixinDevice],
  data() {
    return {
      docList: [],
    };
  },
  created() {
    this.getCert();
  },
  mounted() {
    let that = this;
    this.bodyScale();
    window.onresize = () => {
        that.bodyScale();
    };
  },
  methods: {
    ...mapActions(["Logout"]),
    bodyScale() {
      if(this._isMobile()){return}
      let devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度
      let scale = devicewidth / 1920; // 分母——设计稿的尺寸
      document.body.style.zoom = scale; //放大缩小相应倍数
    },
    getCert() {
      let that = this;
      getAction("/teaching/teachingEventApply/queryMyCert")
        .then((res) => {
          if(res.success){
            this.docList = res.result;
          }else{
            this.$message.info(res.message)
          }
        })
        .catch((e) => {
          if (
            e.response.status == 500 &&
            e.response.data.message.includes("Token失效")
          ) {
            this.$confirm({
              title: "未登录",
              content: "请先登录",
              okText: "去登录",
              onOk() {
                that.$router.push({
                  name: "aidoclogin",
                });
              },
            });
          }
        });
    },
    toCert(url) {
      window.open(url + "?t=" + new Date().getTime());
    },
    toReport(eventApplyId) {
      window.open("/cert/studentReport?eventApplyId=" + eventApplyId);
    },
    toHome(){
      this.$router.push({
        name: "aidocindex",
      });
    },
    logout(){
      const that = this;
      this.$confirm({
        title: "提示",
        content: "是否要退出登录 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              that.$router.push({
                name: "aidocindex",
              });
            })
            .catch((err) => {
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() {},
      });
    }
  },
};
</script>

<style lang="less" scoped>
.bg {
  background: url(./listbg.jpg) no-repeat;
  background-size: cover;
  min-height: 100vh;
  transform-origin: top;
}

.btns{
  float: right;
  padding: 12px;
}
.container {
  max-width: 1600px;
  margin: 0px auto;
  padding-top: 80px;
  .header {
    text-align: center;
    h1 {
      color: #fff;
    }
  }
  .list-wrap {
    margin-top: 64px;
    .list-col {
      max-height: 500px;
      overflow: auto;
    }
    .ant-btn{
      float: right;
    }
  }
}

.footer {
  background: #fff;
  text-align: center;
  bottom: 0;
  position: absolute;
  margin-top: 32px;
  width: 100%;
  height: 32px;
}

.mobile{
  background: url(./listbg2.jpg) no-repeat;
  background-size: 100%;
  transform-origin: top;
  min-height: calc(100vh - 60px);
  .header{
    width: 80%;
    margin: 20px auto;
    color: #666 !important;
    h1{
      color: #666 !important;
      font-size: 20px;
    }
  }
  .list-wrap{
    margin: 0;
    height: calc(100% - 200px);
    background: #fff;
    padding-bottom: 20px;
    overflow-y: auto;
    width: 90%;
    margin: 0 auto;
    padding-bottom: 10px;
  }
  // .footer{
  //   position: unset;
  // }
  .footer {
    text-align: center;
    left: 0;
    right: 0;
    bottom: 0;
    width: 90%;
    height: 50px;
    margin: auto;
    h2{
      font-size: 16px;
    }
  }
}
</style>